import { FC } from "react";
import { Price, SegmentType } from "src/Modules/Flights/constants";
import PriceCard from "../components/PriceCard/PriceCard";
import MiniFareRules from "../components/MiniFareRules/MiniFareRules";
import { FlightInclusions } from "src/Modules/Flights/Pages/JourneyDetails/Steps/Details/components/FlightCard/components";
import AvailableSeats from "../components/AvailableSeats/AvailableSeats";
import JourneyCardTags from "../components/JourneyCardTags/JourneyCardTags";
import JourneyPaths from "../components/JourneyPaths/JourneyPaths";

const JourneyCardMobile: FC<{
  imgUrl: string;
  airline: string;
  segments: SegmentType[];
  priceObject: Price;
  isRefundable: boolean;
  isLcc: boolean;
  miniRules: any[];
  seatsAvailable: number;
}> = ({
  imgUrl,
  airline,
  segments,
  priceObject,
  isRefundable,
  isLcc,
  miniRules,
  seatsAvailable,
}) => {
  return (
    <div className="outline-border-default flex h-full flex-col justify-between gap-3 rounded-md p-4 outline">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img src={imgUrl} className="max-w-8 flex-1 rounded-sm"></img>
          <div className="text-sm">{airline}</div>
        </div>
        <div className="font-medium">
          <JourneyCardTags tags={{ isRefundable, isLcc }} />
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <JourneyPaths segments={segments} />
      </div>
      <div className="flex items-center justify-between">
        <FlightInclusions flight={segments?.[0].flights?.[0]} />
        <AvailableSeats seatsAvailable={seatsAvailable} />
      </div>
      <hr className="border-border-subtle border-t" />
      <div className="flex items-center justify-between">
        <PriceCard priceObject={priceObject} />
        <MiniFareRules miniRules={miniRules} />
      </div>
    </div>
  );
};

export default JourneyCardMobile;
